import React from "react";

import { BetaIntroVideo } from "./components/BetaIntroVideo";

export type AgentAnalyticsContinuation = "insights" | "integrations";

export function AgentAnalyticsLaunchOverview({
  continuation,
}: {
  continuation: AgentAnalyticsContinuation;
}) {
  return (
    <div className="flex flex-col gap-4 text-default">
      <BetaIntroVideo />
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-1.5">
          <h2 className="m-0 font-archivo text-xl font-semibold leading-tight text-default">
            Get from insight to action faster
          </h2>
          <p className="m-0 text-sm leading-relaxed text-muted">
            Replo Agent brings analytics into the same workspace as the pages,
            campaigns, and store experiences you build.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="rounded-lg border-0.5 border-border bg-surface p-3">
            <p className="m-0 font-archivo font-medium text-default">Not now</p>
            <p className="mb-0 mt-1 leading-snug text-muted">
              {continuation === "integrations"
                ? "Continue to Integrations and connect Shopify."
                : "Continue to your existing Insights."}
            </p>
          </div>
          <div className="rounded-lg border-0.5 border-orange bg-orange-soft p-3">
            <p className="m-0 font-archivo font-medium text-default">
              Enable Agent
            </p>
            <p className="mb-0 mt-1 leading-snug text-muted">
              Keep performance context beside the work it informs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
